export default __webpack_public_path__ + "static/media/blog-post-3.9dab8d33.jpg";